import { takeEvery, put, call } from 'redux-saga/effects';
import {
  GET_PRODUCTS,
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  GET_PURCHASES,
  ADD_PURCHASE,
  UPDATE_PURCHASE,
  DELETE_PURCHASE,
  GET_ARRIVED_PURCHASES,
  GET_ARRIVED_PRODUCTS
} from './actionTypes';
import { 
  getProductsSuccess, 
  getProductsFail,
  addProductSuccess,
  addProductFail,
  updateProductSuccess,
  updateProductFail,
  deleteProductSuccess,
  deleteProductFail,
  getPurchasesSuccess,
  getPurchasesFail,
  addPurchaseSuccess,
  addPurchaseFail,
  updatePurchaseSuccess,
  updatePurchaseFail,
  deletePurchaseSuccess,
  deletePurchaseFail,
  getArrivedPurchasesSuccess, 
  getArrivedPurchasesFail, 
  getArrivedProductsSuccess,
  getArrivedProductsFail,
  showLoading, 
  hideLoading 
} from './actions';
import { 
  // getProductsInfo, 
  addProduct, 
  updateProduct, 
  deleteProduct, 
  getPurchasesInfo, 
  addPurchase, 
  updatePurchase, 
  deletePurchase, 
  getArrivedPurchases,
  getArrivedProducts
} from '../../helpers/backend_helper';

import { showToast } from '../../components/Toast';

function* fetchProductsInfo() {
  try {
    yield put(showLoading(true))
    const response = yield call(getPurchasesInfo)
    yield put(getProductsSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getProductsFail(error))
  }
}
function* onAddProduct({ payload: product }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addProduct, product)
    showToast("New Request is added")
    yield put(addProductSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addProductFail(error.response))
  }
}
function* onUpdateProduct({ payload: product }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateProduct, product)
    showToast("Changes Successfully Applied")
    yield put(updateProductSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateProductFail(error))
  }
}
function* onDeleteProduct({ payload: product }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteProduct, product)
    showToast("Request is deleted from the system")
    yield put(deleteProductSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteProductFail(error))
  }
}

function* fetchPurchasesInfo() {
  try {
    yield put(showLoading(true))
    const response = yield call(getPurchasesInfo)
    yield put(getPurchasesSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getPurchasesFail(error))
  }
}
function* onAddPurchase({ payload: purchase }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addPurchase, purchase)
    showToast("New Order is added")
    yield put(addPurchaseSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addPurchaseFail(error.response))
  }
}
function* onUpdatePurchase({ payload: purchase }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updatePurchase, purchase)
    showToast("Changes Successfully Applied")
    yield put(updatePurchaseSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updatePurchaseFail(error))
  }
}
function* onDeletePurchase({ payload: purchase }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deletePurchase, purchase)
    showToast("Request is deleted from the system")
    yield put(deletePurchaseSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deletePurchaseFail(error))
  }
}

function* fetchArrivedProducts({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getArrivedProducts, id);
    yield put(getArrivedProductsSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getArrivedProductsFail(error));
  }
}
function* fetchArrivedPurchases({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getArrivedPurchases, id);
    yield put(getArrivedPurchasesSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getArrivedPurchasesFail(error));
  }
}

function* purchasesSaga() {
  yield takeEvery(GET_PRODUCTS, fetchProductsInfo)
  yield takeEvery(ADD_PRODUCT, onAddProduct)
  yield takeEvery(UPDATE_PRODUCT, onUpdateProduct)
  yield takeEvery(DELETE_PRODUCT, onDeleteProduct)

  yield takeEvery(GET_PURCHASES, fetchPurchasesInfo)
  yield takeEvery(ADD_PURCHASE, onAddPurchase)
  yield takeEvery(UPDATE_PURCHASE, onUpdatePurchase)
  yield takeEvery(DELETE_PURCHASE, onDeletePurchase)

  yield takeEvery(GET_ARRIVED_PRODUCTS, fetchArrivedProducts);
  yield takeEvery(GET_ARRIVED_PURCHASES, fetchArrivedPurchases);
}

export default purchasesSaga;